export default "__VITE_ASSET__DuxtVws2__"